import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { OdbcLinkedService } from '../linkedservice/odbc.linkedservice';


@Metamodel.model({
    name: adfModelTypeMap.odbc.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Odbc_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Odbc_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: OdbcLinkedService.MODEL // Linked service redefined
        }
    }
})
export class OdbcDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
}
